import {  httpPost } from '../../../../../utils/api.utils';
import { convertUtcToLocalDate,  getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelessTerminateModel
    //action
    , setTerminateDate
    , setSubscriptionDetails
    , setFormSubmitted
    , setRequestSelectedData
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-terminate-subscription.settings';

export const terminateModelAInitialState = wirelessTerminateModel;

const defaultState = () => ({
    subscription: {}
    , terminateDate: ''
    , formSubmitted: false
    , requestInBehalf: false
    , isResetLoading: false
});

const initialState = defaultState();

export const wirelessTerminateActions = {

    onSubscriptionSelect: (value, propsName, objects, index) => async (dispatch, state) => {

        const { wirelessTerminateFormA } = state().form;
        const { takeActionSubScriptionDetail, takeActionCircuitCode, takeActionCircuitId } = state().createRequest;

        if (value === '' || value === undefined || !propsName) {
            dispatch(actions.reset('wirelessTerminateFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(propsName) {
                var obj=null
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    } 
                }              
                if (obj != null && obj.CircuitId != wirelessTerminateFormA.circuitId && obj !== undefined) {
                    dispatch(actions.reset('wirelessTerminateFormA.circuitCode'));
                    dispatch(actions.reset('wirelessTerminateFormA.circuitId'));
                    dispatch(actions.reset('wirelessTerminateFormA.vendor'));
                    dispatch(actions.reset('wirelessTerminateFormA.plan'));
                    dispatch(actions.reset('wirelessTerminateFormA.terminateDate'));
                    dispatch(actions.change('wirelessTerminateFormA.circuitCode', value));
                    dispatch(actions.change('wirelessTerminateFormA.circuitId', obj.CircuitId));
                    dispatch(actions.change('wirelessTerminateFormA.vendor',  obj.VendorName));
                    dispatch(actions.change('wirelessTerminateFormA.terminateDate',  obj.OrderDisconnectDate == false ? new Date(convertUtcToLocalDate(obj.OrderDisconnectDate)) : ""));
                    dispatch(actions.change('wirelessTerminateFormA.plan',  obj.PlanName));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                }
            }            
        }
    },

    setRequestSelectedData: () => (dispatch, state) => {
        const { requestData } = state().requestDetail;
        const { subscriptionList } = state().createRequest;
        if (requestData === '' || requestData === undefined) {
            dispatch(actions.reset('wirelessTerminateFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else { 
            dispatch(actions.reset('wirelessTerminateFormA'));
            dispatch(actions.change('wirelessTerminateFormA.circuitCode', requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessTerminateFormA.circuitId', requestData.Circuit.CircuitId));
            dispatch(actions.change('wirelessTerminateFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
            dispatch(actions.change('wirelessTerminateFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation)); 
            dispatch(actions.change('wirelessTerminateFormA.terminateDate',  !requestData.Order.OrderDisconnectDate == false ? new Date(convertUtcToLocalDate(requestData.Order.OrderDisconnectDate)) : ""));
            dispatch(actions.change('wirelessTerminateFormA.vendor',  requestData.Subscription.VendorName));
            dispatch(actions.change('wirelessTerminateFormA.plan',requestData.Subscription.Plan));
            var circuitCodePropName = 'CircuitCode';
            var subscription = subscriptionList ? subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode) : 0;
            dispatch({ type: setSubscriptionDetails, data: subscription });           
        }
    }
    
    , resetWirelessTerminateForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {
        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessTerminateFormA.circuitCode'));
            dispatch(actions.reset('wirelessTerminateFormA.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessTerminateFormA'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
        dispatch(actions.reset('wirelessTerminateFormA'));
        dispatch({ type: setFormSubmitted, data: false });
    }

    , submitRequest: () => async (dispatch, state) => {

        const { wirelessTerminateFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription } = state().wirelessTerminateRequest;
        var dealId = localStorage.getItem('DealId');
        var vendorDetailId = subscription.VendorDetailId == undefined ? subscription[0].VendorDetailId : subscription.VendorDetailId; 
        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        let changeRequestData = {
            ...userData
            , ...wirelessTerminateFormA
            , VendorDetailId: subscription.VendorDetailId
            , terminateDate: wirelessTerminateFormA.terminateDate ? wirelessTerminateFormA.terminateDate : null
            , RequestTypeId: requestTypeId
            , ClientId: dealId
        }

        if (isUpdateRequest) {
            const { requestData } = state().requestDetail;

            changeRequestData = {
                ...changeRequestData,
                OrderId: requestData.Order.OrderId,
                OrderInfoId: requestData.OrderInfoId,
                CircuitOrderId: requestData.CircuitOrderId,
                OrderHistoryId: requestData.OrderHistoryId,
                VendorDetailId: subscription ? vendorDetailId : 0
            }
        }

        var data = {
            ChangeRequestModel: changeRequestData,
            IsAmending: isUpdateRequest
        };

        dispatch({ type: setFormSubmitted, data: true });

        var res = await httpPost('external/terminateRequest/submitTerminateRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setTerminateDate:
            return {
                ...state
                , terminateDate: action.data
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case  setRequestSelectedData:
            return {
                ...state
               , subscription: { ...action.data }
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            }           
        default: return state;
    }
}